import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n

  .use(initReactI18next)

  .init({
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          "Login": "Login",
          "Welcome": "Welcome",
          'Landing1': "You’re about to embark on the journey to earn points and redeem exciting rewards!",
          "Next": "Next",
          'Get Started': 'Get Started',
          'Landing2': 'Upload receipt by purchasing any GoodMorning products.',
          'Upload Receipt': 'Upload Receipt',
          'Collect Points': 'Collect Points',
          'Landing3': 'Collect more points to unlock the tier and redeem exciting rewards!',
          'Log In': 'Log In',
          'LoginText': 'To log in, please provide your phone number:',
          'Enter Number': 'Enter your phone number',
          'OTP Verification': 'OTP Verification',
          'Please enter the verification code': 'Please enter the verification code',
          'Verify': 'Verify',
          'Resend Code': 'Resend Code',
          'Resend Code in': 'Resend Code in',
          'Your number has been verified!': 'Your number has been verified!',
          'Register': 'Register',
          'Registration': 'Registration',
          'CompleteForm': 'Please complete the form to proceed',
          'Full Name': 'Full Name',
          'Date of Birth': 'Date of Birth',
          'Email': 'Email',
          'I Agree': 'I agree to the GoodMorning Global’s',
          'and the': 'and the',
          'I Authorize': 'I authorize GoodMorning Global to share my personal data* with selected third parties to provide value-added services as a G-Connect member.',
          'Submit': 'Submit',
          'Invalid Date of Birth': 'Invalid Date of Birth',
          'DOB Error': 'The date you entered does not meet the eligibility requirements. You must be 18 years old and above to register.',
          'Back': 'Back',
          'HaveAccount': 'Already have an account?',
          'Login Here': 'Login Here',
          'Success': 'Success!',
          'SuccessRegister': 'Your account has been successfully registered.',
          'Done': 'Done',
          'Unsuccessful': 'Unsuccessful',
          'AlreadyRegister': 'This email is already registered. Please use a different email.',
          'Home': 'Home',
          'toGold': 'more to GOLD',
          'toSilver': 'more to SILVER',
          'PointShop': 'Point Shop',
          'ReferEarn': 'Refer & Earn',
          'Badges': 'Badges',
          'My Submissions': 'My Submissions',
          'January': 'January',
          'February': 'February',
          'March': 'March',
          'April': 'April',
          'May': 'May',
          'June': 'June',
          'July': 'July',
          'August': 'August',
          'September': 'September',
          'October': 'October',
          'November': 'November',
          'December': 'December',
          'Approved': 'Approved',
          'Pending': "Pending",
          "Rejected": "Rejected",
          'Upload New': 'Upload New',
          'TermsApply': '*Terms & Conditions apply',
          'Popular Rewards': 'Popular Rewards',
          'View All': 'View All',
          'eWallet Reload Pin': 'eWallet Reload Pin',
          'pts': 'pts',
          'Rewards': 'Rewards',
          'Get 2X Points for First 3 Receipts': 'Get 2X Points for First 3 Receipts',
          'History': 'History',
          'Profile': 'Profile',
          'My Points': 'My Points',
          'My Rewards': 'My Rewards',
          'All': "All",
          'Item': "Item",
          'View Cart': 'View Cart',
          'Voucher': "Voucher",
          'ProductInfo': 'Product Information',
          'Cart': 'Cart',
          'Address': 'Address',
          'Select Address': 'Select Address',
          'Total': 'Total',
          'Checkout': 'Proceed to Checkout',
          'Redeem Reward': 'Redeem Reward?',
          'Redeem': 'Redeem',
          'ConfirmRedeem': "Are you sure you want to redeem this reward? Your points will be deducted once details confirmation is done.",
          "Cancel": 'Cancel',
          'Confirm': 'Confirm',
          'SuccessRedeem': 'You have successfully completed your redemption.',
          'GoRewards': 'Go to Rewards',
          TnG: "Touch 'n Go eWallet Reload PIN valued at RM",
          'Reward description': 'The reward will be shipped within 14 working days.',
          'exp.': 'exp.',
          'Tap to Reveal': 'Tap to Reveal',
          'Voucher Expired': 'Voucher Expired',
          'Redeemed On': 'Redeemed On',
          'copied': 'Copied to clipboard',
          'Coming Soon': 'Coming Soon',
          workingOn: "We're working on something amazing that we can't wait to share with you.",
          'Check Back': 'Check back soon for updates!',
          'Close': 'Close',
          'UploadPhoto': 'Upload a photo of your receipt',
          'AddedCart': 'Added to cart successfully!',
          'Receipt Amount': 'Receipt Amount',
          'EnterAmount': 'Enter your amount',
          'Receipt Date': 'Receipt Date',
          'DD/MM/YYYY': 'DD/MM/YYYY',
          'Receipt Number': 'Receipt Number',
          'EnterNumber': 'Enter receipt number',
          'Receipt Sample': 'Receipt Sample',
          'Sample': 'Sample of physical receipt:',
          'Store Name': 'Store Name',
          'InvoiceNo': 'Receipt / Invoice No.',
          'Product Name': 'Product Name',
          ESample: 'Sample of e-commerce receipt:',
          'Lazada Invoice': 'Lazada Invoice',
          'Shopee Invoice': 'Shopee Invoice',
          SuccessUpload: 'Your receipt has been successfully uploaded and will be validated within 5 working days.',
          'Sure?': 'Are you sure?',
          'DeleteSure': 'Are you sure you want to delete this item?',
          'Delete': 'Delete',
          'Points Earned': 'Points Earned',
          'Points': 'Points',
          'Personal Details': 'Personal Details',
          'Delivery Details': 'Delivery Details',
          'Refer a Friend': 'Refer a Friend',
          'Tiering': 'Tiering',
          'Language': 'Language',
          'Help': 'Help',
          'Preferences': 'Preferences',
          'Logout': 'Logout',
          'Email Address': 'Email Address',
          'Phone Number': 'Phone Number',
          'Save': 'Save',
          'DetailsUpdate': 'Your details have been successfully updated.',
          'EditAddress': 'Edit Delivery Address',
          'AddAddress': 'Add New Address',
          'DeliveryAddress': 'Enter your address for delivery.',
          'MobileNumber': 'Mobile Number',
          'Name': 'Name',
          'Line1': 'Address line 1',
          'EnterLine1': 'Enter your address (line 1)',
          'Line2': 'Address line 2',
          'EnterLine2': 'Enter your address (line 2)',
          'City': 'City',
          'ZIP / Postcode': 'ZIP / Postcode',
          'Postcode': 'Postcode',
          'AddressSaved': 'Address has been successfully saved.',
          'Tiering Benefits': 'Tiering Benefits',
          'Tiering Points Required': 'Tiering Points Required',
          'Privileges': 'Privileges',
          'Welcome Reward': 'Welcome Reward',
          'Referral Rewards': 'Referral Rewards',
          'Yearly': 'Yearly',
          'Tiering Expiring': 'Tiering Expiring',
          'Birthday Rewards': 'Birthday Rewards',
          'FAQ': 'FAQ',
          'T&C': 'T&C',
          'Terms & Conditions': 'Terms & Conditions',
          'Terms and Conditions': 'Terms and Conditions',
          'Privacy Policy': 'Privacy Policy',
          'Campaign Related': 'Campaign Related',
          'General': 'General',
          'I would like to receive communication from GoodMorning Global about nutritional information, member benefits, latest products updates, member offers and other information. Contact GoodMorning Global for any questions. For further reading, please read': 'I would like to receive communication from GoodMorning Global about nutritional information, member benefits, latest products updates, member offers and other information. Contact GoodMorning Global for any questions. For further reading, please read no',
          'Direct Mail': 'Direct Mail',
          'SMS': 'SMS',
          'Phone Call': 'Phone Call',
          'Call': 'Call',
          'I would like to receive communication on product updates, promotions & loyalty program from GoodMorning Global. You can unsubscribe at any time by updating this page.': 'I would like to receive communication on product updates, promotions & loyalty program from GoodMorning Global. You can unsubscribe at any time by updating this page.',
          'SPEND AND WIN': 'SPEND AND WIN',
          'Prizes worth over': 'Prizes worth over',
          'Prizes': 'Prizes',
          'How To Win': 'How To Win',
          'GRAND PRIZE': 'GRAND PRIZE',
          '10 x Cash RM2,888': '10 x Cash RM2,888',
          'CONSOLATION': 'CONSOLATION',
          'Bi-Weekly Prize': 'Bi-Weekly Prize',
          'Go to your shopping cart and select your purchases to "Check Out".': 'Go to your shopping cart and select your purchases to "Check Out".',
          'At the Checkout page.': 'At the Checkout page.',
          'Enter your promotion code on the Gift Card in the "Enter Voucher Code" field and tap on the "Apply" button to redeem your Gift Card.': 'Enter your promotion code on the Gift Card in the "Enter Voucher Code" field and tap on the "Apply" button to redeem your Gift Card.',
          'Once applied, continue to check out by tapping on the "Proceed to Checkout" button for the website or "Place Order" button to continue the payment and complete the purchase.': 'Once applied, continue to check out by tapping on the "Proceed to Checkout" button for the website or "Place Order" button to continue the payment and complete the purchase.',
          'Add To Cart': 'Add To Cart',
          'Your Cart is Currently Empty': 'Your Cart is Currently Empty',
          'BeforeProceed': 'Before proceeding to the checkout page, ensure you have added everything you need in this cart.',
          'Return to Point Shop': 'Return to Point Shop',
          'Refer & Earn': 'Refer & Earn',
          'Refer friends, get EXTRA points!': 'Refer friends, get EXTRA points!',
          'How does it work?': 'How does it work?',
          'Invite Your Friends': 'Invite Your Friends',
          'Share your referral link.': 'Share your referral link.',
          'They earn 10 points.': 'They earn 10 points.',
          'Your friend will earn 10 points for using your link.': 'Your friend will earn 10 points for using your link.',
          'You earn too!': 'You earn too!',
          'For each referral you get 10 points!': 'For each referral you get 10 points!',
          'Points History': 'Points History',
          'How to Redeem?': 'How to Redeem?',
          "How to Redeem Your Touch 'n Go Reload PIN?": "How to Redeem Your Touch 'n Go Reload PIN?",
          "Open the Touch 'n Go eWallet Reload PIN App": "Open the Touch 'n Go eWallet Reload PIN App",
          'Click "Reload"': 'Click "Reload"',
          'Click "eWallet Balance"': 'Click "eWallet Balance"',
          'Click on "TNG eWallet Reload PIN" below of the page': 'Click on "TNG eWallet Reload PIN" below of the page',
          'Key in the TNG eWallet Reload PIN and click "Reload Now"': 'Key in the TNG eWallet Reload PIN and click "Reload Now"',
          "Successfully redeem Touch 'n Go eWallet voucher": "Successfully redeem Touch 'n Go eWallet voucher",
          "Only ONE (1) Reload PIN Reward can be used per reload": "Only ONE (1) Reload PIN Reward can be used per reload",
          'To utilize the Reload Pin, log in on the microsite. At "Rewards", tap on the "View Now" button under your rewards. Then, tap on the copy icon next to the Voucher Code of the respective rewards and follow the steps provided.': 'To utilize the Reload Pin, log in on the microsite. At "Rewards", tap on the "View Now" button under your rewards. Then, tap on the copy icon next to the Voucher Code of the respective rewards and follow the steps provided.',
          'Used Reload Pin Reward are non-reversible. Once used, the amount is not exchangeable nor refundable for credits, cash or such replacement in part or in full.': 'Used Reload Pin Reward are non-reversible. Once used, the amount is not exchangeable nor refundable for credits, cash or such replacement in part or in full.',
          'TNG Digital will not in any way contact users for any personal information or account credentials for this Campaign.': 'TNG Digital will not in any way contact users for any personal information or account credentials for this Campaign.',
          'Reload Pin will be expired on': 'Reload Pin will be expired on',
          'Exclusive Discount for': 'Exclusive Discount for',
          'Redemption rewards ONLY': 'Redemption rewards ONLY',
          'Your details have been successfully updated.': 'Your details have been successfully updated.',
          'It seems like the one-time PIN you entered is incorrect. Please try again with the correct code.': 'It seems like the one-time PIN you entered is incorrect. Please try again with the correct code.',
          'NOTE: This submission is entitled to 2X Points': "NOTE: This submission is entitled to 2X Points",
          'Points Spent': 'Points Spent',
          'Get 2X Points for First 3 Purchases of the Month': 'Get 2X Points for First 3 Purchases of the Month',
          'Items': 'Items',
          'Subtotal': 'Subtotal',
          'Please select at least one valid item to proceed.': 'Please select at least one valid item to proceed.',
          'Discount': 'Discount',
          'Are you sure you want to delete this address info?': 'Are you sure you want to delete this address info?',
          'Yes': 'Yes',
          'No': 'No',
          'Expires On': 'Expires On',
          'Enter your name': 'Enter your name',
          'Enter your mobile number': 'Enter your mobile number',
          'Copy': 'Copy',
          'above': 'above',
          'Rejected': 'Rejected',
          'Your submission has been rejected:': 'Your submission has been rejected',
          'Kindly upload your receipt again.': 'Kindly upload your receipt again',
          'Upload Again': 'Upload Again',
          'Uploading...': 'Uploading...',
          'Later': 'Later',
          "Contest Requirement - The required campaign hashtag is missing.": "Contest Requirement - The required campaign hashtag is missing.",
          "Contest Requirement - The participant did not tag a friend, as required by the contest rules.": "Contest Requirement - The participant did not tag a friend, as required by the contest rules.",
          "Receipt Photo Issue - The same receipt was uploaded more than once.": "Receipt Photo Issue - The same receipt was uploaded more than once.",
          "Receipt Photo Issue - The same product was uploaded more than once.": "Receipt Photo Issue - The same product was uploaded more than once.",
          "Receipt Photo Issue - The receipt photo is too blurry to be read clearly.": "Receipt Photo Issue - The receipt photo is too blurry to be read clearly.",
          "Receipt Photo Issue - The receipt is too wrinkled and illegible.": "Receipt Photo Issue - The receipt is too wrinkled and illegible.",
          "Receipt Photo Issue - The uploaded image is not a receipt": "Receipt Photo Issue - The uploaded image is not a receipt",
          "Receipt Photo Issue - Receipts must be submitted separately.": "Receipt Photo Issue - Receipts must be submitted separately.",
          "Receipt Photo Issue - A handwritten receipt  is not accepted.": "Receipt Photo Issue - A handwritten receipt  is not accepted.",
          "Receipt Photo Issue - A product image is not accepted": "Receipt Photo Issue - A product image is not accepted",
          "Missing Receipt Info - The receipt does not show the store name.": "Missing Receipt Info - The receipt does not show the store name.",
          "Missing Receipt Info - The receipt is missing the purchase date.": "Missing Receipt Info - The receipt is missing the purchase date.",
          "Missing Receipt Info - The invoice or receipt number is not visible.": "Missing Receipt Info - The invoice or receipt number is not visible.",
          "Missing Receipt Info - The total purchase amount is not shown on the receipt.": "Missing Receipt Info - The total purchase amount is not shown on the receipt.",
          "Incomplete Info - The personal information provided is incomplete.": "Incomplete Info - The personal information provided is incomplete.",
          "Invalid Purchase - The product is not a participating product": "Invalid Purchase - The product is not a participating product",
          "Invalid Purchase - The purchase does not meet the minimum requirement": "Invalid Purchase - The purchase does not meet the minimum requirement",
          "Campaign Period Issue - The receipt dated outside the campaign period.": "Campaign Period Issue - The receipt dated outside the campaign period.",
          "Campaign Period Issue - The campaign has ended.": "Campaign Period Issue - The campaign has ended.",
          "Store Eligibility - The store is not a participating outlet": "Store Eligibility - The store is not a participating outlet",
          "Receipt Content Issue - The rebate  is not reflected on the receipt.": "Receipt Content Issue - The rebate  is not reflected on the receipt.",
          "Redemption Limit - The maximum number of redemptions has been reached.": "Redemption Limit - The maximum number of redemptions has been reached.",
          "Redemption Limit - The rewards have been fully redeemed.": "Redemption Limit - The rewards have been fully redeemed.",
          "Eligibility - The participant is not a Malaysian citizen.": "Eligibility - The participant is not a Malaysian citizen.",
          "Eligibility - Does not meet the minimum age required.": "Eligibility - Does not meet the minimum age required.",
          "Eligibility - The image does not match the info provided": "Eligibility - The image does not match the info provided",
          "Invalid receipt - must be submitted within 7 days from receipt date": "Invalid receipt - must be submitted within 7 days from receipt date",
          "Invalid receipt - must be submitted within 60 days from receipt date": "Invalid receipt - must be submitted within 60 days from receipt date",
          "Eligibility - mismatch / missing required product image": "Eligibility - mismatch / missing required product image",
          "Contest Requirement - missing the required hashtag": "Contest Requirement - missing the required hashtag",
          "Contest Requirement - not tagging a friend as required": "Contest Requirement - not tagging a friend as required",
          "Receipt Photo Issue - uploading the same receipt more than once": "Receipt Photo Issue - uploading the same receipt more than once",
          "Receipt Photo Issue - a blurry photo – we can't read the receipt clearly": "Receipt Photo Issue - a blurry photo – we can't read the receipt clearly",
          "Receipt Photo Issue - the receipt being too wrinkled to read properly": "Receipt Photo Issue - the receipt being too wrinkled to read properly",
          "Receipt Photo Issue - an image that doesn't look like a valid receipt": "Receipt Photo Issue - an image that doesn't look like a valid receipt",
          "Receipt Photo Issue - combining multiple receipts in one image – please send them separately": "Receipt Photo Issue - combining multiple receipts in one image – please send them separately",
          "Receipt Photo Issue - submitting a handwritten receipt, which isn't accepted": "Receipt Photo Issue - submitting a handwritten receipt, which isn't accepted",
          "Receipt Photo Issue - uploading the same product image more than once": "Receipt Photo Issue - uploading the same product image more than once",
          "Receipt Photo Issue - submitting a product image (Physical), which isn't accepted": "Receipt Photo Issue - submitting a product image (Physical), which isn't accepted",
          "Missing Receipt Info - missing the store name": "Missing Receipt Info - missing the store name",
          "Missing Receipt Info - missing the invoice or receipt number": "Missing Receipt Info - missing the invoice or receipt number",
          "Missing Receipt Info - not showing the total purchase amount": "Missing Receipt Info - not showing the total purchase amount",
          "Incomplete Info - incomplete personal information": "Incomplete Info - incomplete personal information",
          "Invalid Purchase - a product that isn't included in the campaign": "Invalid Purchase - a product that isn't included in the campaign",
          "Invalid Purchase - a purchase that didn't meet the minimum spending amount required": "Invalid Purchase - a purchase that didn't meet the minimum spending amount required",
          "Campaign Period Issue - a receipt dated outside the campaign period": "Campaign Period Issue - a receipt dated outside the campaign period",
          "Campaign Period Issue - redeeming outside the campaign period": "Campaign Period Issue - redeeming outside the campaign period",
          "Store Eligibility - buying from a store that's not participating in the campaign": "Store Eligibility - buying from a store that's not participating in the campaign",
          "Receipt Content Issue - the rebate or offer not being shown on the receipt": "Receipt Content Issue - the rebate or offer not being shown on the receipt",
          "Redemption Limit - reaching the maximum number of redemptions allowed": "Redemption Limit - reaching the maximum number of redemptions allowed",
          "Redemption Limit - all rewards for the campaign already being fully redeemed": "Redemption Limit - all rewards for the campaign already being fully redeemed",
          "Eligibility - not being a Malaysian citizen": "Eligibility - not being a Malaysian citizen",
          "Eligibility - not meeting the minimum age required to join the campaign": "Eligibility - not meeting the minimum age required to join the campaign",
          "Eligibility - mismatch identified between user input and image provided.": "Eligibility - mismatch identified between user input and image provided."
        }
      },
      bm: {
        translation: {
          "Login": "Log Masuk",
          "Welcome": "Selamat Datang",
          'Landing1': "Anda akan mula meraih mata dan tebus ganjaran yang menarik!",
          "Next": "Seterus",
          'Get Started': 'Mula',
          'Landing2': 'Upload receipt by purchasing any GoodMorning products.',
          'Upload Receipt': 'Muat Naik Resit',
          'Collect Points': 'Kumpulkan Mata',
          'Landing3': 'Kumpulkan lebih banyak mata untuk membuka lapisan dan tebus ganjaran yang menarik!',
          'Log In': 'Log Masuk',
          'LoginText': 'Untuk log masuk, sila berikan nombor telefon anda:',
          'Enter Number': 'Masukkan nombor telefon anda',
          'OTP Verification': 'Pengesahan OTP',
          'Please enter the verification code': 'Sila masukkan kod pengesahan yang telah dihantar',
          'Verify': 'Sahkan',
          'Resend Code': 'Hantar semula kod',
          'Resend Code in': ' Hantar semula kod dalam',
          'Your number has been verified!': 'Nombor anda telah disahkan!',
          'Register': 'Daftar',
          'Registration': 'Pendaftaran',
          'CompleteForm': 'Sila lengkapkan borang untuk meneruskan',
          'Full Name': 'Nama Penuh',
          'Date of Birth': 'Tarikh Lahir',
          'Email': 'Emel',
          'I Agree': 'Saya bersetuju dengan Terma dan Syarat serta Polisi Privasi GoodMorning Global.',
          'and the': 'serta',
          'I Authorize': 'Saya memberi kebenaran kepada GoodMorning Global untuk berkongsi data peribadi saya* dengan pihak ketiga yang dipilih untuk menyediakan perkhidmatan bernilai tambah sebagai ahli G-Connect.',
          'Submit': 'Hantar',
          'Invalid Date of Birth': 'Tarikh lahir tidak sah',
          'DOB Error': 'Tarikh lahir anda tidak memenuhi syarat. Anda perlu berumur 18 tahun atau lebih untuk mendaftar.',
          'Back': 'Kembali',
          'HaveAccount': 'Sudah memiliki akaun?',
          'Login Here': 'Log Masuk Di Sini',
          'Success': 'Berjaya!',
          'SuccessRegister': 'Akaun anda berjaya didaftarkan.',
          'Done': 'Selesai',
          'Unsuccessful': 'Tidak Berjaya',
          'AlreadyRegister': 'Emel ini sudah didaftarkan. Sila gunakan emel yang berbeza.',
          'Home': 'Laman Utama',
          'toGold': 'mata lagi untuk EMAS',
          'toSilver': 'mata lagi untuk PERAK',
          'PointShop': 'Kedai Mata',
          'ReferEarn': 'Rujuk & Tebus',
          'Badges': 'Lencana',
          'My Submissions': 'Hantaran Saya',
          'January': 'Januari',
          'February': 'Februari',
          'March': 'Mac',
          'April': 'April',
          'May': 'Mei',
          'June': 'Jun',
          'July': 'Julai',
          'August': 'Ogos',
          'September': 'September',
          'October': 'Oktober',
          'November': 'November',
          'December': 'Disember',
          'Approved': 'Diluluskan',
          'Pending': "Belum Diluluskan",
          'Processing': "Dalam Proses",
          "Rejected": "Ditolak",
          'Upload New': 'Muat Naik Baru',
          'TermsApply': '*Terma & Syarat terpakai"',
          'Member\'s Day': 'Hari Ahli',
          'Starts in': 'Mula dalam:',
          'Ends in:': 'Berakhir dalam:',
          'Days': 'Hari',
          "Shop as Usual": "Beli Seperti Biasa",
          "Make a purchase of any GoodMorning product on 18th from participating stores.": "Buat pembelian mana-mana produk GoodMorning pada 18hb di kedai yang mengambil bahagian.",
          "Submit Your Receipt": "Hantar Resit Anda",
          "Upload the receipt for your GoodMorning purchase made on the 18th": "Muat naik resit untuk pembelian GoodMorning anda yang dibuat pada 18hb",
          "Earn 2x Points!": "Dapatkan 2x Mata!",
          "Once approved, your points will be doubled automatically!": "Sebaik sahaja diluluskan, mata anda akan digandakan secara automatik!",
          "Member's Day": "Hari Ahli",
          "Earn": "Dapatkan",
          "on 18th Every Month!": "pada 18hb Setiap Bulan!",
          "Normal day": "Hari biasa",
          "(Upon spending RM50)": "(Dengan perbelanjaan RM50)",
          "On 18th": "Pada 18hb",
          "2x Points": "2x Mata",
          "How does it work?": "Bagaimana ia berfungsi?",
          "Enjoy this exclusive reward on the 18th of every month - don't miss it!": "Nikmati ganjaran eksklusif ini pada 18hb setiap bulan - jangan lepaskan!",
          "Submit now": "Hantar sekarang",
          'Popular Rewards': 'Ganjaran Popular',
          'View All': 'Lihat Semua',
          'eWallet Reload Pin': 'Pin Topup eWallet',
          'pts': 'mata',
          'Rewards': 'Ganjaran',
          'History': 'Sejarah',
          'Profile': 'Profil',
          'My Points': 'Mata Saya',
          'My Rewards': 'Ganjaran Saya',
          'All': "Semua",
          'Item': "Item",
          'View Cart': 'Lihat Troli',
          'Voucher': "Baucer",
          'ProductInfo': 'Maklumat Produk',
          'Cart': 'Troli',
          'Address': 'Alamat',
          'Select Address': 'Pilih Alamat',
          'Total': 'Jumlah',
          'Checkout': 'Teruskan ke Checkout',
          'Redeem Reward': "Tebus Ganjaran?",
          'Redeem': 'Tebus',
          'ConfirmRedeem': "Adakah anda pasti ingin tebus ganjaran ini? Mata anda akan dikurangkan setelah pengesahan butiran selesai.",
          "Cancel": 'Batal',
          'Confirm': 'Sahkan',
          'SuccessRedeem': 'Anda telah berjaya menyelesaikan penebusan anda.',
          'GoRewards': 'Pergi ke Ganjaran',
          TnG: "PIN Tambah Nilai Touch 'n Go eWallet bernilai RM",
          'Reward description': 'Ganjaran akan dihantar dalam masa 14 hari bekerja.',
          'exp.': 'tamat pada:',
          'Tap to Reveal': 'Klik untuk Buka',
          'Voucher Expired': 'Tamat Tempoh',
          'Redeemed On': 'Tebus Pada',
          'copied': 'Disalin ke papan keratan',
          'Coming Soon': 'Segera Datang',
          workingOn: "Kami sedang bekerja pada sesuatu yang menakjubkan yang kami tidak sabar untuk berkongsi dengan anda.",
          'Check Back': 'Sila semak kembali untuk kemas kini!',
          'Close': 'Tutup',
          'UploadPhoto': 'Muat Naik gambar resit anda',
          'AddedCart': 'Berjaya ditambah ke troli!',
          'Receipt Amount': 'Jumlah Resit',
          'EnterAmount': 'Masukkan jumlah',
          'Receipt Date': 'Tarikh Resit',
          'DD/MM/YYYY': 'DD/MM/YYYY',
          'Receipt Number': 'Nombor Resit',
          'EnterNumber': 'Masukkan nombor resit',
          'Receipt Sample': 'Sampel Resit',
          'Sample': 'Contoh resit fizikal:',
          'Store Name': 'Nama Kedai',
          'InvoiceNo': 'Nombor Resit / Invois',
          'Product Name': 'Nama Produk',
          ESample: 'Contoh resit e-dagang:',
          'Lazada Invoice': 'Invois Lazada',
          'Shopee Invoice': 'Invois Shopee',
          SuccessUpload: 'Resit anda telah berjaya dimuat naik dan akan disahkan dalam masa 5 hari bekerja.',
          'Sure?': 'Anda pasti?',
          'DeleteSure': 'Adakah anda pasti ingin memadamkan item ini?',
          'Delete': 'Padam',
          'Points Earned': 'Mata Diperolehi',
          'Points': 'Mata',
          'Personal Details': 'Maklumat Peribadi',
          'Get 2X Points for First 3 Receipts': 'Dapatkan 2X Mata untuk Resit Pertama 3 kali',
          'Delivery Details': 'Maklumat Penghantaran',
          'Refer a Friend': 'Rujuk Kepada Rakan',
          'Tiering': 'Pengkelasan',
          'Language': 'Bahasa',
          'Help': 'Bantuan',
          'Preferences': 'Keutamaan',
          'Logout': 'Log Keluar',
          'Email Address': 'Alamat Emel',
          'Phone Number': 'Nombor Telefon',
          'Save': 'Simpan',
          'DetailsUpdate': 'Maklumat anda telah berjaya dikemaskini.',
          'EditAddress': 'Edit Alamat Penghantaran',
          'AddAddress': 'Tambah Alamat Baru',
          'DeliveryAddress': 'Masukkan alamat penghantaran anda.',
          'MobileNumber': 'Nombor Telefon Bimbit',
          'Name': 'Nama',
          'Line1': 'Alamat Baris 1',
          'EnterLine1': 'Masukkan alamat anda (baris 1)',
          'Line2': 'Alamat Baris 2',
          'EnterLine2': 'Masukkan alamat anda (baris 2)',
          'City': 'Bandar',
          'ZIP / Postcode': 'ZIP / Poskod',
          'Postcode': 'Poskod',
          'AddressSaved': 'Alamat telah berjaya disimpan.',
          'Tiering Benefits': 'Faedah Pengkelasan',
          'Tiering Points Required': 'Mata Pengkelasan Diperlukan:',
          'Privileges': 'Keistimewaan',
          'Welcome Reward': 'Ganjaran Selamat Datang',
          'Referral Rewards': 'Ganjaran Rujukan',
          'Yearly': 'Setiap Tahun',
          'Tiering Expiring': 'Pengkelasan akan tamat',
          'Birthday Rewards': 'Ganjaran Hari Jadi',
          'FAQ': 'Soalan Lazim',
          'Terms & Conditions': 'Terma & Syarat',
          'T&C': 'Terma dan Syarat',
          'Terms and Conditions': 'Terma dan Syarat',
          'Privacy Policy': 'Dasar Privasi',
          'Campaign Related': 'Berkaitan Kempen',
          'General': 'Umum',
          'I would like to receive communication from GoodMorning Global about nutritional information, member benefits, latest products updates, member offers and other information. Contact GoodMorning Global for any questions. For further reading, please read': 'Saya ingin menerima komunikasi dari GoodMorning Global mengenai maklumat pemakanan, faedah ahli, kemas kini produk terkini, tawaran ahli, dan maklumat lain. Hubungi GoodMorning Global untuk sebarang pertanyaan. Untuk bacaan lanjut, sila baca',
          'Direct Mail': 'Mel Direct',
          'SMS': 'SMS',
          'Phone Call': 'Panggilan Telefon',
          'Call': 'Panggilan',
          'I would like to receive communication on product updates, promotions & loyalty program from GoodMorning Global. You can unsubscribe at any time by updating this page.': 'Saya ingin menerima komunikasi mengenai kemas kini produk, promosi & program kesetiaan dari GoodMorning Global. Anda boleh berhenti langganan pada bila-bila masa dengan mengemaskini halaman ini.',
          'SPEND AND WIN': 'BELI DAN MENANG',
          'Prizes worth over': 'Hadiah bernilai lebih dari',
          'Prizes': 'Hadiah',
          'How To Win': 'Cara Menang',
          'GRAND PRIZE': 'HADIAH UTAMA',
          '10 x Cash RM2,888': '10 x Tunai RM2,888',
          'CONSOLATION': 'SAGUHATI',
          'Bi-Weekly Prize': 'Hadiah Setiap Dua Minggu',
          'Go to your shopping cart and select your purchases to "Check Out".': 'Pergi ke troli beli-beli anda dan pilih pembelian anda untuk "Pembayaran".',
          'At the Checkout page.': 'Di halaman Pembayaran.',
          'Enter your promotion code on the Gift Card in the "Enter Voucher Code" field and tap on the "Apply" button to redeem your Gift Card.': 'Masukkan kod promosi anda pada Kad Hadiah di dalam medan "Masukkan Kod Baucer" dan ketuk butang "Apply" untuk menebus Kad Hadiah anda.',
          'Once applied, continue to check out by tapping on the "Proceed to Checkout" button for the website or "Place Order" button to continue the payment and complete the purchase.': 'Setelah diterapkan, teruskan ke halaman pembayaran dengan mengetuk butang "Proceed to Checkout" untuk laman web atau butang "Place Order" untuk aplikasi untuk meneruskan pembayaran dan menyelesaikan pembelian.',
          'Add To Cart': 'Tambah ke troli',
          'Your Cart is Currently Empty': 'Troli anda kini kosong',
          'BeforeProceed': 'Sebelum ke halaman pembayaran, pastikan anda telah menambahkan segala yang anda perlukan di dalam troli ini.',
          'Return to Point Shop': 'Kembali ke Kedai Mata',
          'Refer & Earn': 'Rujuk & Jana',
          'Refer friends, get EXTRA points!': 'Rujuk rakan, dapatkan mata EXTRA!',
          'How does it work?': "Bagaimana ia berfungsi?",
          'Invite Your Friends': 'Jemput Rakan Anda',
          'Share your referral link.': 'Kongsi pautan rujukan anda',
          'They earn 10 points.': 'Mereka memperoleh 10 mata.',
          'Your friend will earn 10 points for using your link.': 'Rakan anda akan memperoleh 10 mata apabila menggunakan pautan anda.',
          'You earn too!': 'Anda juga mendapat ganjaran!',
          'For each referral you get 10 points!': 'Untuk setiap rujukan, anda akan mendapat 10 mata!',
          'Points History': 'Sejarah Mata',
          'How to Redeem?': 'Cara Penebusan?',
          "How to Redeem Your Touch 'n Go Reload PIN?": "Cara Penebusan Touch 'n Go Reload PIN Anda:",
          "Open the Touch 'n Go eWallet Reload PIN App": "Buka Aplikasi Touch 'n Go eWallet Reload PIN",
          'Click "Reload"': 'Klik "Reload"',
          'Click "eWallet Balance"': 'Klik "Baki eWallet "',
          'Click on "TNG eWallet Reload PIN" below of the page': 'Klik "TNG eWallet Reload PIN" di bawah halaman',
          'Key in the TNG eWallet Reload PIN and click "Reload Now"': 'Masukkan TNG eWallet Reload PIN dan klik "Reload Now"',
          "Successfully redeem Touch 'n Go eWallet voucher": "Berjaya menebus baucar Touch 'n Go eWallet",
          "Only ONE (1) Reload PIN Reward can be used per reload": "Hanya SATU (1) Ganjaran Reload PIN boleh digunakan setiap kali reload",
          'To utilize the Reload Pin, log in on the microsite. At "Rewards", tap on the "View Now" button under your rewards. Then, tap on the copy icon next to the Voucher Code of the respective rewards and follow the steps provided.': 'Untuk menggunakan Reload Pin, log masuk ke mikrositus. Di "Rewards", ketuk butang "Lihat Sekarang" di bawah ganjaran anda. Kemudian, ketuk ikon salin di sebelah Voucher Code ganjaran yang bersesuaian dan ikuti langkah-langkah yang disediakan.',
          'Used Reload Pin Reward are non-reversible. Once used, the amount is not exchangeable nor refundable for credits, cash or such replacement in part or in full.': 'Ganjaran Reload Pin yang telah digunakan tidak boleh dibalikkan. Setelah digunakan, jumlah itu tidak boleh ditukar atau dikembalikan untuk kredit, wang tunai atau penggantian seumpama sepenuhnya atau sebahagian.',
          'TNG Digital will not in any way contact users for any personal information or account credentials for this Campaign.': 'TNG Digital tidak akan menghubungi pengguna untuk sebarang maklumat peribadi atau kelayakan akaun untuk Kempen ini.',
          'Reload Pin will be expired on': 'Reload Pin akan tamat tempoh pada',
          'Exclusive Discount for': 'Diskaun Eksklusif untuk',
          'Redemption rewards ONLY': 'Penebusan Ganjaran SAHAJA',
          'Your details have been successfully updated.': 'Butiran anda telah berjaya dikemaskini.',
          'It seems like the one-time PIN you entered is incorrect. Please try again with the correct code.': 'Nampaknya PIN satu kali yang anda masukkan tidak betul. Sila cuba lagi dengan kod yang betul.',
          'NOTE: This submission is entitled to 2X Points': "NOTA: Penghantaran ini berhak mendapat 2X Mata",
          'Points Spent': 'Mata Dibelanjakan',
          'Get 2X Points for First 3 Purchases of the Month': 'Dapatkan 2X Mata untuk 3 Pembelian Pertama Bulan Ini',
          'Items': 'Item',
          'Subtotal': 'Jumlah Sebahagian',
          'Please select at least one valid item to proceed.': 'Sila pilih sekurang-kurangnya satu item yang sah untuk meneruskan.',
          'Discount': 'Diskaun',
          'Are you sure you want to delete this address info?': 'Adakah anda pasti mahu memadam maklumat alamat ini?',
          'Yes': 'Ya',
          'No': 'Tidak',
          'Expires On': 'Tamat Pada',
          'Enter your name': 'Masukkan nama anda',
          'Enter your mobile number': 'Masukkan nombor telefon bimbit anda',
          'Copy': 'Salin',
          'above': 'ke atas',
          "Member\'s Day 2x Points" : 'Hari Ahli 2x Mata',
          "Happy Hour: Bonus for x3.5 multiplier": "Waktu Gembira: Bonus untuk x3.5 perkali",
          'Rejected': 'Ditolak',
          'Your submission has been rejected:': 'Penyerahan anda telah ditolak:',
          'Kindly upload your receipt again.': 'Sila muat naik resit anda sekali lagi.',
          'Upload Again': 'Muat Naik Semula',
          'Uploading...': 'Memuat Naik...',
          'Later': 'Kemudian',
          "Contest Requirement - The required campaign hashtag is missing.": "Hashtag kempen yang diperlukan tidak disertakan.",
          "Contest Requirement - The participant did not tag a friend, as required by the contest rules.": "Keperluan Peraduan – tidak menanda (tag) rakan seperti yang diperlukan.",
          "Receipt Photo Issue - The same receipt was uploaded more than once.": "Resit yang sama dimuat naik lebih daripada sekali.",
          "Receipt Photo Issue - The same product was uploaded more than once.": "Isu Foto Resit – memuat naik imej produk yang sama lebih daripada sekali.",
          "Receipt Photo Issue - The receipt photo is too blurry to be read clearly.": "Isu Foto Resit – foto kabur dan resit tidak dapat dibaca dengan jelas.",
          "Receipt Photo Issue - The receipt is too wrinkled and illegible.": "Isu Foto Resit – resit terlalu berkedut sehingga sukar dibaca.",
          "Receipt Photo Issue - The uploaded image is not a receipt": "Isu Foto Resit – imej yang tidak kelihatan seperti resit yang sah.",
          "Receipt Photo Issue - Receipts must be submitted separately.": "Isu Foto Resit – menggabungkan beberapa resit dalam satu imej – sila hantar secara berasingan.",
          "Receipt Photo Issue - A handwritten receipt  is not accepted.": "Isu Foto Resit – menghantar resit tulisan tangan, yang tidak diterima.",
          "Receipt Photo Issue - A product image is not accepted": "Isu Foto Resit – menghantar imej produk (fizikal), yang tidak diterima.",
          "Missing Receipt Info - The receipt does not show the store name.": "Maklumat Resit Tidak Lengkap – tiada nama kedai.",
          "Missing Receipt Info - The receipt is missing the purchase date.": "Maklumat Resit Tidak Lengkap – tiada tarikh pembelian.",
          "Missing Receipt Info - The invoice or receipt number is not visible.": "Maklumat Resit Tidak Lengkap – tiada nombor invois atau resit.",
          "Missing Receipt Info - The total purchase amount is not shown on the receipt.": "Maklumat Resit Tidak Lengkap – jumlah pembelian tidak dipaparkan.",
          "Incomplete Info - The personal information provided is incomplete.": "Maklumat Tidak Lengkap – maklumat peribadi tidak lengkap.",
          "Invalid Purchase - The product is not a participating product": "Pembelian Tidak Sah – produk yang tidak termasuk dalam kempen.",
          "Invalid Purchase - The purchase does not meet the minimum requirement": "Pembelian Tidak Sah – pembelian tidak memenuhi jumlah perbelanjaan minimum yang diperlukan.",
          "Campaign Period Issue - The receipt dated outside the campaign period.": "Isu Tempoh Kempen – resit bertarikh di luar tempoh kempen.",
          "Campaign Period Issue - The campaign has ended.": "Kempen telah tamat.",
          "Store Eligibility - The store is not a participating outlet": "Kelayakan Kedai – pembelian dibuat di kedai yang tidak mengambil bahagian dalam kempen.",
          "Receipt Content Issue - The rebate  is not reflected on the receipt.": "Isu Kandungan Resit – rebat atau tawaran tidak ditunjukkan pada resit.",
          "Redemption Limit - The maximum number of redemptions has been reached.": "Had Penebusan – telah mencapai jumlah maksimum penebusan yang dibenarkan.",
          "Redemption Limit - The rewards have been fully redeemed.": "Had Penebusan – semua ganjaran untuk kempen telah ditebus sepenuhnya.",
          "Eligibility - The participant is not a Malaysian citizen.": "Kelayakan – bukan warganegara Malaysia.",
          "Eligibility - Does not meet the minimum age required.": "Kelayakan – tidak memenuhi umur minimum yang diperlukan untuk menyertai kempen.",
          "Eligibility - The image does not match the info provided": "Kelayakan – terdapat ketidakpadanan antara maklumat pengguna dengan imej yang dihantar.",
          "Invalid receipt - must be submitted within 7 days from receipt date": "Resit Tidak Sah – mesti dihantar dalam tempoh 7 hari dari tarikh resit.",
          "Invalid receipt - must be submitted within 60 days from receipt date": "Resit Tidak Sah – mesti dihantar dalam tempoh 60 hari dari tarikh resit.",
          "Eligibility - mismatch / missing required product image": "Kelayakan – ketidakpadanan / tiada imej produk yang diperlukan.",
          "Contest Requirement - missing the required hashtag": "Keperluan Peraduan - tiada hashtag yang diperlukan",
          "Contest Requirement - not tagging a friend as required": "Keperluan Peraduan - tidak menandakan rakan seperti yang diperlukan",
          "Receipt Photo Issue - uploading the same receipt more than once": "Isu Foto Resit - memuat naik resit yang sama lebih daripada sekali",
          "Receipt Photo Issue - a blurry photo – we can't read the receipt clearly": "Isu Foto Resit - gambar kabur – resit tidak dapat dibaca dengan jelas",
          "Receipt Photo Issue - the receipt being too wrinkled to read properly": "Isu Foto Resit - resit terlalu berkedut untuk dibaca dengan betul",
          "Receipt Photo Issue - an image that doesn't look like a valid receipt": "Isu Foto Resit - imej tidak kelihatan seperti resit yang sah",
          "Receipt Photo Issue - combining multiple receipts in one image – please send them separately": "Isu Foto Resit - menggabungkan beberapa resit dalam satu imej – sila hantar secara berasingan",
          "Receipt Photo Issue - submitting a handwritten receipt, which isn't accepted": "Isu Foto Resit - menghantar resit tulisan tangan, yang tidak diterima",
          "Receipt Photo Issue - uploading the same product image more than once": "Isu Foto Resit - memuat naik imej produk yang sama lebih daripada sekali",
          "Receipt Photo Issue - submitting a product image (Physical), which isn't accepted": "Isu Foto Resit - menghantar imej produk (fizikal), yang tidak diterima",
          "Missing Receipt Info - missing the store name": "Maklumat Resit Hilang - tiada nama kedai",
          "Missing Receipt Info - missing the invoice or receipt number": "Maklumat Resit Hilang - tiada nombor invois atau resit",
          "Missing Receipt Info - not showing the total purchase amount": "Maklumat Resit Hilang - jumlah pembelian tidak dipaparkan",
          "Incomplete Info - incomplete personal information": "Maklumat Tidak Lengkap - maklumat peribadi tidak lengkap",
          "Invalid Purchase - a product that isn't included in the campaign": "Pembelian Tidak Sah - produk tidak termasuk dalam kempen",
          "Invalid Purchase - a purchase that didn't meet the minimum spending amount required": "Pembelian Tidak Sah - pembelian tidak mencapai jumlah perbelanjaan minimum yang diperlukan",
          "Campaign Period Issue - a receipt dated outside the campaign period": "Isu Tempoh Kempen - resit bertarikh di luar tempoh kempen",
          "Campaign Period Issue - redeeming outside the campaign period": "Isu Tempoh Kempen - penebusan di luar tempoh kempen",
          "Store Eligibility - buying from a store that's not participating in the campaign": "Kelayakan Kedai - membeli dari kedai yang tidak menyertai kempen",
          "Receipt Content Issue - the rebate or offer not being shown on the receipt": "Isu Kandungan Resit - rebat atau tawaran tidak dipaparkan pada resit",
          "Redemption Limit - reaching the maximum number of redemptions allowed": "Had Penebusan - mencapai jumlah maksimum penebusan yang dibenarkan",
          "Redemption Limit - all rewards for the campaign already being fully redeemed": "Had Penebusan - semua ganjaran untuk kempen telah ditebus sepenuhnya",
          "Eligibility - not being a Malaysian citizen": "Kelayakan - bukan warganegara Malaysia",
          "Eligibility - not meeting the minimum age required to join the campaign": "Kelayakan - tidak mencapai umur minimum yang diperlukan untuk menyertai kempen",
          "Eligibility - mismatch identified between user input and image provided.": "Kelayakan - ketidakpadanan dikenal pasti antara input pengguna dan imej yang diberikan."
        }
      },
      cn: {
        translation: {
          "Login": "登录",
          "Welcome": "欢迎",
          'Landing1': "您即将踏上赚取积分和兑换令人兴奋奖励的旅程！",
          "Next": "下面",
          'Get Started': '开始',
          'Landing2': '通过购买任何早安产品上传收据',
          'Upload Receipt': '上传收据',
          'Collect Points': '收集积分',
          'Landing3': '收集更多积分以解锁层级并兑换惊喜好康奖励！',
          'Log In': '登录',
          'LoginText': '请提供您的手机号码登录：',
          'Enter Number': '输入您的手机号码',
          'OTP Verification': 'OTP 验证',
          'Please enter the verification code': '请输入您的验证码',
          'Verify': '验证',
          'Resend Code': '重新发送验证码',
          'Resend Code in': ' 重新发送验证码',
          'Your number has been verified!': '您的号码已验证！',
          'Register': '注册',
          'Registration': '注册',
          'CompleteForm': '请填写表格以继续',
          'Full Name': '全名',
          'Date of Birth': '出生日期',
          'Email': '电子邮件',
          'I Agree': '我同意 GoodMorning Global 的条款和条件以及隐私政策。',
          'and the': '以及',
          'I Authorize': '我授权 GoodMorning Global 与选定的第三方分享我的个人数据*，以作为 G-Connect 会员提供增值服务。',
          'Submit': '提交',
          'Invalid Date of Birth': '无效的出生日期',
          'DOB Error': '您输入的日期不符合资格要求。您必须年满 18 岁才能注册。',
          'Back': '返回',
          'HaveAccount': '已有帐号？',
          'Get 2X Points for First 3 Receipts': '首 3 张收据可获得双倍积分',
          'Login Here': '在此登录',
          'Success': '成功！',
          'SuccessRegister': '您的帐户已成功注册。',
          'Done': '完成',
          'Unsuccessful': '不成功',
          'AlreadyRegister': '此电子邮件已注册。请使用其他电子邮件。',
          'Home': '主页',
          'toGold': '距离黄金还有',
          'toSilver': '距离白银还很远',
          'PointShop': '积分商城',
          'ReferEarn': '推荐并赚取',
          'Badges': '徽章',
          'My Submissions': '我的提交',
          'January': '一月',
          'February': '二月',
          'March': '三月',
          'April': '四月',
          'May': '五月',
          'June': '六月',
          'July': '七月',
          'August': '八月',
          'September': '九月',
          'October': '十月',
          'November': '十一月',
          'December': '十二月',
          'Approved': '已批准',
          'Processing': "处理中",
          'Pending': "待定",
          "Rejected": "已拒绝",
          'Upload New': '上传新的',
          'TermsApply': '*适用条款和条件',
          'Popular Rewards': '热门奖励',
          'View All': '查看全部',
          'eWallet Reload Pin': '电子钱包充值代码',
          'pts': '积分',
          'Rewards': '奖励',
          'History': '历史',
          'Profile': '个人资料',
          'My Points': '我的积分',
          'My Rewards': '我的奖励',
          'All': "所有",
          'Item': "商品",
          'View Cart': '查看购物车',
          'Voucher': "优惠券",
          'ProductInfo': '产品信息',
          'Cart': '购物车',
          'Address': '地址',
          'Select Address': '选择地址',
          'Total': '总计',
          'Checkout': '前往结账',
          'Redeem Reward': '兑换奖励吗？',
          'Redeem': '兑换',
          'ConfirmRedeem': "您确定要兑换这个奖励吗？一旦详细确认完成，您的积分将被扣除。",
          "Cancel": '取消',
          'Confirm': '确认',
          'SuccessRedeem': '您已成功完成兑换。',
          'GoRewards': '前往奖励',
          TnG: "Touch 'n Go 电子钱包充值 PIN，价值 RM",
          'Reward description': '奖励将在 14 工作日内寄出。',
          'exp.': '截止日期:',
          'Tap to Reveal': '点击显示',
          'Voucher Expired': '票券已过期',
          'Redeemed On': '兑换于',
          'copied': '已复制到剪贴板',
          'Coming Soon': '即将推出',
          workingOn: "惊喜好康不断，请随时检查更新，",
          'Check Back': "敬请期待！",
          'Close': '关闭',
          'UploadPhoto': '上传收据照片',
          'AddedCart': '已成功添加到购物车',
          'Receipt Amount': '收据金额',
          'EnterAmount': '输入金额',
          'Receipt Date': '收据日期',
          'DD/MM/YYYY': '日/月/年',
          'Receipt Number': '收据编号',
          'EnterNumber': '输入收据编号',
          'Receipt Sample': '收据样本',
          'Sample': '实体收据样本：',
          'Store Name': '商店名称',
          'InvoiceNo': '收据/发票编号',
          'Product Name': '产品名称',
          ESample: '电子商务收据样本：',
          'Lazada Invoice': 'Lazada 发票',
          'Shopee Invoice': 'Shopee 发票',
          SuccessUpload: '您的收据已成功上传，并将在 5 个工作日内进行验证。',
          'Sure?': '您确定吗？',
          'DeleteSure': '您确定要删除此商品吗？',
          'Delete': '删除',
          'Points Earned': '积分累计',
          'Points': '积分',
          'Personal Details': '个人详情',
          'Delivery Details': '送货详情',
          'Refer a Friend': '推荐朋友',
          'Tiering': '分层',
          'Language': '语言',
          'Help': '帮助',
          'Preferences': '首选设定',
          'Logout': '推出',
          'Email Address': '电子邮件地址',
          'Phone Number': '电话号码',
          'Save': '保存',
          'DetailsUpdate': '您的信息已成功更新。',
          'EditAddress': '编辑送货地址',
          'AddAddress': '添加新地址',
          'DeliveryAddress': '输入送货地址。',
          'MobileNumber': '手机号码',
          'Name': '名字',
          'Line1': '地址行 1',
          'EnterLine1': '输入您的地址（行 1）',
          'Line2': '地址行 2',
          'EnterLine2': '输入您的地址（行 2）',
          'City': '城市',
          'ZIP / Postcode': '邮政编码',
          'Postcode': '邮政编码',
          'AddressSaved': '地址已成功保存。',
          'Tiering Benefits': '分层福利',
          'Tiering Points Required': '需要的分层积分',
          'Privileges': '福利',
          'Welcome Reward': '欢迎奖励',
          'Referral Rewards': '推荐奖励',
          'Yearly': '每年',
          'Tiering Expiring': '分层即将到期',
          'Birthday Rewards': '生日奖励',
          'FAQ': '常见问题',
          'T&C': '条款与条件',
          '16px Conditions': '条款与条件',
          'Terms & Conditions': '条款与条件',
          'Privacy Policy': '隐私政策',
          'Campaign Related': '活动相关',
          'General': '一般',
          'I would like to receive communication from GoodMorning Global about nutritional information, member benefits, latest products updates, member offers and other information. Contact GoodMorning Global for any questions. For further reading, please read': '我希望收到来自 GoodMorning Global 关于营养的资讯、最新产品更新、会员福利、优惠及其他信息的讯息。有任何问题请联系 GoodMorning Global。欲了解更多，请阅读',
          'Direct Mail': '直邮',
          'SMS': '短信',
          'Phone Call': '电话',
          'Call': '拨电',
          'I would like to receive communication on product updates, promotions & loyalty program from GoodMorning Global. You can unsubscribe at any time by updating this page.': '我希望收到 GoodMorning Global 关于产品更新、促销和忠诚计划的讯息。您可以随时通过更新此页面来取消订阅。',
          'SPEND AND WIN': '消费赢奖',
          'Prizes worth over': '总价值超过的奖品',
          'Prizes': '奖品',
          'How To Win': '如何赢取',
          'GRAND PRIZE': '大奖',
          '10 x Cash RM2,888': '10 份现金 RM2,888',
          'CONSOLATION': '安慰奖',
          'Bi-Weekly Prize': '每两周奖品',
          'Go to your shopping cart and select your purchases to "Check Out".': '到购物车并选择要购买的商品进行 "结账" 。',
          'At the Checkout page.': '在结账页面。',
          'Enter your promotion code on the Gift Card in the "Enter Voucher Code" field and tap on the "Apply" button to redeem your Gift Card.': '在 "礼卡" 栏位中输入您的优惠代码，并点击 "应用" 按钮以兑换您的礼卡。',
          'Once applied, continue to check out by tapping on the "Proceed to Checkout" button for the website or "Place Order" button to continue the payment and complete the purchase.': '应用后，点击 "结账" 以付款并完成订单。',
          'Add To Cart': '加入购物车',
          'Your Cart is Currently Empty': '您的购物车目前是空的',
          'BeforeProceed': '到结账页面之前，请确保您已将所需的一切添加到购物车中。',
          'Return to Point Shop': '返回积分商店',
          'Refer & Earn': '推荐并赚取',
          'Refer friends, get EXTRA points!': '推荐朋友，赚取额外积分',
          'How does it work?': '如何运作?',
          'Invite Your Friends': '邀请您的朋友',
          'Share your referral link.': '分享您的推荐链接。',
          'They earn 10 points.': '他们获得 10 积分。',
          'Your friend will earn 10 points for using your link.': '您的朋友使用您的链接后将获得 10 积分。',
          'You earn too!': '您也能获得奖励！',
          'For each referral you get 10 points!': '每推荐一人，您将获得 10 积分！',
          'Points History': '积分历史',
          'How to Redeem?': '如何兑换?',
          "How to Redeem Your Touch 'n Go Reload PIN?": "如何兑换您的 Touch 'n Go 电子钱包充值 PIN？",
          "Open the Touch 'n Go eWallet Reload PIN App": "打开 Touch 'n Go 电子钱包充值 PIN 应用程序",
          'Click "Reload"': '点击 "充值" ',
          'Click "eWallet Balance"': '点击 "电子钱包余额"',
          'Click on "TNG eWallet Reload PIN" below of the page': '在页面下方点击 "TNG 电子钱包充值 PIN"',
          'Key in the TNG eWallet Reload PIN and click "Reload Now"': '输入 TNG 电子钱包充值 PIN 并点击 "立即充值"',
          "Successfully redeem Touch 'n Go eWallet voucher": "成功兑换 Touch 'n Go 电子钱包券",
          "Only ONE (1) Reload PIN Reward can be used per reload": "每次充值只能使用一个 (1) 充值 PIN 奖励",
          'To utilize the Reload Pin, log in on the microsite. At "Rewards", tap on the "View Now" button under your rewards. Then, tap on the copy icon next to the Voucher Code of the respective rewards and follow the steps provided.': '使用充值 PIN，请登录到微网站。 在 "奖励" 下方点击 "立即查看" 。 然后，点击奖励的 Voucher Code 旁的复制图标，然后按照提供的步骤进行操作。',
          'Used Reload Pin Reward are non-reversible. Once used, the amount is not exchangeable nor refundable for credits, cash or such replacement in part or in full.': '兑换的充值 PIN 奖励不可逆转。 一旦使用，该金额不可用于部分或全额充值、现金、替代转让或退款。',
          'TNG Digital will not in any way contact users for any personal information or account credentials for this Campaign.': 'TNG Digital 将不以任何方式联系用户以获取此活动的任何个人信息或帐户验证。',
          'Reload Pin will be expired on': 'Reload Pin 将于',
          'Exclusive Discount for': '仅限于奖励兑换',
          'Redemption rewards ONLY': '的折扣',
          'Your details have been successfully updated.': '您的信息已成功更新。',
          'It seems like the one-time PIN you entered is incorrect. Please try again with the correct code.': '您输入的一次性验证码不正确。请使用正确的验证码重试。',
          'NOTE: This submission is entitled to 2X Points': "注意：此次提交将获得双倍积分",
          'Points Spent': '已使用积分',
          'Get 2X Points for First 3 Purchases of the Month': '每月首 3 张收据可获得双倍积分',
          'Items': '项目',
          'Subtotal': '小计',
          'Please select at least one valid item to proceed.': '请选择至少一个有效项目以继续。',
          'Discount': '折扣',
          'Are you sure you want to delete this address info?': '您确定要删除此地址信息？',
          'Yes': '是',
          'No': '否',
          'Expires On': '截止日期',
          'Enter your name': '输入您的姓名',
          'Enter your mobile number': '输入您的手机号码',
          'Copy': '复制',
          'above': '以上',
          "Shop as Usual": "照常购物",
          "Make a purchase of any GoodMorning product on 18th from participating stores.": "在18号于参与活动的商店购买任何GoodMorning产品。",
          "Submit Your Receipt": "提交您的收据",
          "Upload the receipt for your GoodMorning purchase made on the 18th": "上传您在18号购买GoodMorning产品的收据",
          "Earn 2x Points!": "获得双倍积分！",
          "Once approved, your points will be doubled automatically!": "一旦审核通过，您的积分将自动加倍！",
          "Member's Day": "会员日",
          "Earn": "获得",
          "on 18th Every Month!": "每月18号！",
          "Normal day": "普通日",
          "(Upon spending RM50)": "（消费满RM50）",
          "On 18th": "在18号",
          "2x Points": "双倍积分",
          "How does it work?": "如何运作？",
          "Enjoy this exclusive reward on the 18th of every month - don't miss it!": "每月18号享受此专属奖励——不要错过！",
          "Submit now": "立即提交",
          "Member's Day": "会员日",
          "Starts in": "开始于：",
          "Ends in:": "结束于：",
          "Days": "天",
          "Member\'s Day 2x Points" : '会员日 2x 积分',
          "Happy Hour: Bonus for x3.5 multiplier": "快餐时间：x3.5倍奖励",
          'Rejected': '已拒绝',
          'Your submission has been rejected:': '您的提交已被拒绝：',
          'Kindly upload your receipt again.': '请重新上传您的收据。',
          'Upload Again': '重新上传',
          'Uploading...': '上传中...',
          'Later': '稍后',
          "Contest Requirement - The required campaign hashtag is missing.": "活动要求 - 缺少必需的标签（Hashtag）。",
          "Contest Requirement - The participant did not tag a friend, as required by the contest rules.": "活动要求 - 未按要求标记朋友。",
          "Receipt Photo Issue - The same receipt was uploaded more than once.": "收据照片问题 - 重复上传同一张收据。",
          "Receipt Photo Issue - The same product was uploaded more than once.": "收据照片问题 - 重复上传同一产品图片。",
          "Receipt Photo Issue - The receipt photo is too blurry to be read clearly.": "收据照片问题 - 照片模糊，无法清晰读取收据内容。",
          "Receipt Photo Issue - The receipt is too wrinkled and illegible.": "收据照片问题 - 收据过于皱褶，无法清楚辨认。",
          "Receipt Photo Issue - The uploaded image is not a receipt": "收据照片问题 - 图片看起来并不像有效的收据。",
          "Receipt Photo Issue - Receipts must be submitted separately.": "收据照片问题 - 将多张收据拍摄在同一张图片中，请分别上传。",
          "Receipt Photo Issue - A handwritten receipt  is not accepted.": "收据照片问题 - 上传了手写收据，恕不接受。",
          "Receipt Photo Issue - A product image is not accepted": "收据照片问题 - 上传了产品实物照片，恕不接受。",
          "Missing Receipt Info - The receipt does not show the store name.": "收据信息缺失 - 缺少商店名称。",
          "Missing Receipt Info - The receipt is missing the purchase date.": "收据信息缺失 - 缺少购买日期。",
          "Missing Receipt Info - The invoice or receipt number is not visible.": "收据信息缺失 - 缺少发票或收据编号。",
          "Missing Receipt Info - The total purchase amount is not shown on the receipt.": "收据信息缺失 - 未显示总购买金额。",
          "Incomplete Info - The personal information provided is incomplete.": "信息不完整 - 个人信息填写不完整。",
          "Invalid Purchase - The product is not a participating product": "无效购买 - 购买的产品不在活动范围内。",
          "Invalid Purchase - The purchase does not meet the minimum requirement": "无效购买 - 未达到活动规定的最低消费金额。",
          "Campaign Period Issue - The receipt dated outside the campaign period.": "活动期间问题 - 收据日期不在活动期间内。",
          "Campaign Period Issue - The campaign has ended.": "活动已结束。",
          "Store Eligibility - The store is not a participating outlet": "店铺资格问题 - 所购店铺未参与此次活动。",
          "Receipt Content Issue - The rebate  is not reflected on the receipt.": "收据内容问题 - 收据上未显示回扣或优惠信息。",
          "Redemption Limit - The maximum number of redemptions has been reached.": "兑换次数限制 - 已达到允许的兑换次数上限。",
          "Redemption Limit - The rewards have been fully redeemed.": "兑换次数限制 - 活动所有奖品已被兑换完毕。",
          "Eligibility - The participant is not a Malaysian citizen.": "资格不符 - 非马来西亚公民。",
          "Eligibility - Does not meet the minimum age required.": "资格不符 - 未达到参与活动的最低年龄要求。",
          "Eligibility - The image does not match the info provided": "资格不符 - 用户填写信息与所提供图片不一致。",
          "Invalid receipt - must be submitted within 7 days from receipt date": "无效收据 - 必须在收据日期起7天内提交。",
          "Invalid receipt - must be submitted within 60 days from receipt date": "无效收据 - 必须在收据日期起60天内提交。",
          "Eligibility - mismatch / missing required product image": "资格不符 - 缺少或上传了错误的必需产品图片。",
          "Contest Requirement - missing the required hashtag": "比赛要求 - 缺少必要的标签",
          "Contest Requirement - not tagging a friend as required": "比赛要求 - 未按要求标记朋友",
          "Receipt Photo Issue - uploading the same receipt more than once": "收据照片问题 - 上传相同收据超过一次",
          "Receipt Photo Issue - a blurry photo – we can't read the receipt clearly": "收据照片问题 - 照片模糊，收据无法清晰读取",
          "Receipt Photo Issue - the receipt being too wrinkled to read properly": "收据照片问题 - 收据过于皱褶，无法正常读取",
          "Receipt Photo Issue - an image that doesn't look like a valid receipt": "收据照片问题 - 图片看起来不像有效的收据",
          "Receipt Photo Issue - combining multiple receipts in one image – please send them separately": "收据照片问题 - 将多张收据合并在一张图片中，请分别提交",
          "Receipt Photo Issue - submitting a handwritten receipt, which isn't accepted": "收据照片问题 - 提交的为手写收据，不被接受",
          "Receipt Photo Issue - uploading the same product image more than once": "收据照片问题 - 上传相同的产品图片超过一次",
          "Receipt Photo Issue - submitting a product image (Physical), which isn't accepted": "收据照片问题 - 提交了产品图片（实物），不被接受",
          "Missing Receipt Info - missing the store name": "收据信息缺失 - 缺少商店名称",
          "Missing Receipt Info - missing the invoice or receipt number": "收据信息缺失 - 缺少发票或收据号码",
          "Missing Receipt Info - not showing the total purchase amount": "收据信息缺失 - 未显示购买总金额",
          "Incomplete Info - incomplete personal information": "信息不完整 - 个人信息不完整",
          "Invalid Purchase - a product that isn't included in the campaign": "无效购买 - 产品未包含在活动中",
          "Invalid Purchase - a purchase that didn't meet the minimum spending amount required": "无效购买 - 未达到最低消费金额要求",
          "Campaign Period Issue - a receipt dated outside the campaign period": "活动期间问题 - 收据日期不在活动期间内",
          "Campaign Period Issue - redeeming outside the campaign period": "活动期间问题 - 在活动期外进行兑换",
          "Store Eligibility - buying from a store that's not participating in the campaign": "商店资格 - 从未参与活动的商店购买",
          "Receipt Content Issue - the rebate or offer not being shown on the receipt": "收据内容问题 - 收据上未显示折扣或优惠",
          "Redemption Limit - reaching the maximum number of redemptions allowed": "兑换限制 - 已达到允许的最大兑换次数",
          "Redemption Limit - all rewards for the campaign already being fully redeemed": "兑换限制 - 本次活动的所有奖励已全部兑完",
          "Eligibility - not being a Malaysian citizen": "资格 - 不是马来西亚公民",
          "Eligibility - not meeting the minimum age required to join the campaign": "资格 - 未达到参加活动的最低年龄要求",
          "Eligibility - mismatch identified between user input and image provided.": "资格 - 用户输入与提供的图片不一致"
        }
      }
    },
    lng: localStorage.getItem("language") && localStorage.getItem("language") === "en" ? "en" : localStorage.getItem("language") === "bm" ? "bm" : "cn"
  });

export default i18n;
